import { ChangeEvent, FormEvent, useState } from "react";
import { SoftwareCreate } from "../../models/Softwares/SoftwareCreate";
import { Box, Button, TextField } from "@mui/material";

interface Props {
  closeForm: () => void;
  create: (software: SoftwareCreate) => void;
}

export default function CreateSoftwareForm({ closeForm, create }: Props) {
  const [softwareData, setSoftwareData] = useState<SoftwareCreate>({
    softwareName: "",
    prefixName: "",
    description: "",
  });

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();
    create(softwareData);
  }

  function handleInputChange(event: ChangeEvent<HTMLInputElement>) {
    const { name, value } = event.target;
    setSoftwareData({ ...softwareData, [name]: value });
  }

  return (
    <Box component="form" onSubmit={handleSubmit} >
      <TextField
        label="Software Name"
        name="softwareName"
        value={softwareData.softwareName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Prefix Name"
        name="prefixName"
        value={softwareData.prefixName}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        required
      />

      <TextField
        label="Description"
        name="description"
        value={softwareData.description}
        onChange={handleInputChange}
        fullWidth
        margin="normal"
        multiline
      />

      <Box sx={{ mt: 2, display: "flex", gap: 2 }}>
        <Button type="submit" variant="contained" color="primary">
          Create
        </Button>
        <Button variant="outlined" onClick={closeForm}>
          Cancel
        </Button>
      </Box>
    </Box>
  );
}
